import React from "react";
import { useEffect, useState, useRef } from "react";
import Joyride, { EVENTS, STATUS } from "react-joyride";
import TooltipBottomBar from "../../../Shared/Components/TooltipBottomBar/TooltipBottomBar";
import { chipsAudioContent, chipsContent, chipsHeading1, chipsHeading2, GridAudioContent, GridContent, GridHeading1, GridHeading2, inputAudioContent, inputHeading1, inputHeading2, introAudioContent, introHeading1, introHeading2, MicAudioContent, MicContent, MicEndAudioContent, MicEndContent, MicEndHeading1, MicEndHeading2, MicHeading1, MicHeading2, MicIntroAudioContent, MicIntroContent, MicIntroHeading1, MicIntroHeading2, sendAudioContent, sendHeaning1, sendHeaning2, speakerAudioContent, speakerHeading1, speakerHeading2, tooltipButtons, tooltipChipsContent, tooltipDefaultChipsContent, tooltipEndAudioContent, tooltipEndContent, tooltipEndHeading1, tooltipEndHeading2, tooltipInputContent, tooltipIntroContent, tooltipLoaderContent, tooltipLoaderHeading1, tooltipLoaderHeading2, tooltipMicContent, tooltipQuestionChipsAudioContent, tooltipQuestionChipsContent, tooltipQuestionChipsHeading1, tooltipQuestionChipsHeading2, tooltipSendContent, tooltipSendQuestion, tooltipSourceAudioContent, tooltipSourceContent, tooltipSourceHeading1, tooltipSourceHeading2, tooltipSpeakerContent, tooltipStarAudioContent, tooltipStarContent, tooltipStarHeading1, tooltipStarHeading2 } from "../../../NewConstants/TooltipConstants";
import { getUserToken, stopPlayingAudio, updateTooltipFlag } from "../../../Actions/Utils";
import { sendTooltipStepStatus } from '../../../Actions/ChatActions';
import { useNavigate } from "react-router-dom";
import "./Tooltip.css";

const Tooltip = ({
  start,
  setStartTour,
  onTourEnd,
  selectedLanguage,
  audioRef,
  speakerEnabled,
  setSpeakerEnabled = () => {},
  lastWelcomeIdx,
  lastQuestionChipsIdx = () => {},
  speakerOpen,
  setSpeakerOpen,
  setInput = () => {},
  optionClicked,
  setOptionClicked = () => {},
  chipsClicked,
  setChipsClicked = () => {},
  optionSelected,
  setOptionSelected = () => {},
  setDefaultChipsClicked = () => {},
  showQuestionChips,
  setShowQuestionChips,
  lastStarIdx = () => {},
  setDefaultQuestionChipsClicked,
  questionChipsClicked,
  showTooltipStar,
  setShowTooltipStar,
  lastSourceIdx,
  setQuestionChipsClicked,
  setDefaultShowTooltipStar,
  setToastErrorMessage,
  setShowToastMessage,
  stepIndex,
  setStepIndex,
  sendClicked,
  setSendClicked,
}) => {
  const totalSteps = 16;
  const [isSpeakerOn, setIsSpeakerOn] = useState(true);
  const [isSpeakerToggled, setIsSpeakerToggled] = useState(false);
  const [progress, setProgress] = useState(1);
  const [run, setRun] = useState(start);
  const [steps, setSteps] = useState(generateSteps(progress, lastQuestionChipsIdx, lastStarIdx));
  const navigate = useNavigate();
  const [showNextButton, setShowNextButton] = useState(false);

  useEffect(() => {
    if (stepIndex === 0){
      setProgress(1);
      setSpeakerOpen(false);
      setOptionClicked(false);
      setChipsClicked(false);
      setShowQuestionChips(false);
      setQuestionChipsClicked(false);
      setShowTooltipStar(false);
      setDefaultQuestionChipsClicked(false);
      setOptionSelected(false);
      setDefaultChipsClicked(false);
      setDefaultShowTooltipStar(false);
      setSendClicked(false);
    }
  }, [stepIndex]);

  useEffect(() => {
    setShowNextButton(false);
    const timer = setTimeout(() => {
      setShowNextButton(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, [stepIndex]);
  function tooltipContent (val, heading1, heading2, speechText, text) {
    return (
    <div className="m-0">
          <TooltipBottomBar
            stepIndex={stepIndex}
            heading1={heading1}
            heading2={heading2}
            speechText={speechText}
            text={text}
            isPlaying={false}
            audioRef={audioRef}
            selectedLanguage={selectedLanguage}
            speakerEnabled={speakerEnabled}
            setSpeakerEnabled={setSpeakerEnabled}
            index={val}
            speakerOpen={speakerOpen}
            isSpeakerOn={isSpeakerOn}
            setIsSpeakerOn={setIsSpeakerOn}
          />
          <div className="absolute bottom-[1rem] left-[1rem] text-sm text-neutral-400" style={{display: val === 11 || val === 13 ? "none" : ""}}>
            {val} of {totalSteps}
          </div>
        </div>
  );
  };
  function generateSteps (val, lastQuestionChipsIdx, lastStarIdx) {
    return [
    {
      content: tooltipContent(val, introHeading1[selectedLanguage], introHeading2[selectedLanguage], introAudioContent[selectedLanguage], tooltipIntroContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
      },
      placement: "center",
      target: "body",
    },
    {
      content: tooltipContent(val, speakerHeading1[selectedLanguage], speakerHeading2[selectedLanguage], speakerAudioContent[selectedLanguage], tooltipSpeakerContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "50%",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
      disableBeacon: true,
      spotlightClicks: true,
      placement: "bottom",
      target: lastWelcomeIdx !== undefined ? `#tour-speaker-chat-block-${lastWelcomeIdx}` : ".tour-speaker-chat-block:last-child",
      title: "",
    },
    {
        content: tooltipContent(val, speakerHeading1[selectedLanguage], speakerHeading2[selectedLanguage], speakerAudioContent[selectedLanguage], tooltipSpeakerContent[selectedLanguage]),
        styles: {
          options: {
            width: 380,
          },
          spotlight: {
            borderRadius: "1.25rem",
            boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
          },
        },
        spotlightClicks: true,
        placement: "top",
        target: lastWelcomeIdx !== undefined ? `#tour-narration-chat-block-${lastWelcomeIdx}` : ".tour-narration-chat-block:last-of-type",
        title: "",
    },
    {
      content: tooltipContent(val, inputHeading1[selectedLanguage], inputHeading2[selectedLanguage], inputAudioContent[selectedLanguage], tooltipInputContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
      },
      placement: "top",
      target: "#tour-input-bar",
      title: "",
      disableBeacon: true,
      spotlightClicks: true,
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "2rem",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
    },
    {
      content: tooltipContent(val, sendHeaning1[selectedLanguage], sendHeaning2[selectedLanguage], sendAudioContent[selectedLanguage], tooltipSendContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "2rem",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
      placement: "bottom",
      target: "#tour-send-button",
      title: "",
      spotlightClicks: true,
      disableBeacon: true,
    },
    {
      content: tooltipContent(val, MicIntroHeading1[selectedLanguage], MicIntroHeading2[selectedLanguage], MicIntroAudioContent[selectedLanguage], MicIntroContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
      },
      placement: "center",
      target: "body",
    },
    {
      content: tooltipContent(val, MicHeading1[selectedLanguage], MicHeading2[selectedLanguage], MicAudioContent[selectedLanguage], MicContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "2rem",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
      placement: "top",
      target: "#tour-mic-button",
      title: "",
      spotlightClicks: false,
      disableBeacon: true,
    },
    {
      content: tooltipContent(val, MicEndHeading1[selectedLanguage], MicEndHeading2[selectedLanguage], MicEndAudioContent[selectedLanguage], MicEndContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "2rem",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
      placement: "top",
      target: "#tour-mic-button",
      title: "",
      spotlightClicks: false,
      disableBeacon: true,
    },
    {
      content: tooltipContent(val, GridHeading1[selectedLanguage], GridHeading2[selectedLanguage], GridAudioContent[selectedLanguage], GridContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "5.269rem",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
      placement: "top",
      target: "#tour-grid-button",
      title: "",
      spotlightClicks: true,
      disableBeacon: true,
    },
    {
      content: tooltipContent(val, chipsHeading1[selectedLanguage], chipsHeading2[selectedLanguage], chipsAudioContent[selectedLanguage], chipsContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "1.25rem",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
      placement: "top",
      target: "#tour-chips-button",
      title: "",
      spotlightClicks: true,
      disableBeacon: true,
    },
    {
      content: tooltipContent(val, tooltipLoaderHeading1[selectedLanguage], tooltipLoaderHeading2[selectedLanguage], "", tooltipLoaderContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        footer: {
          display: "none",
        }
      },
      placement: "center",
      target: "body",
      hideFooter: true,
      hideNextButton: true,
    },
    {
      content: tooltipContent(val, tooltipQuestionChipsHeading1[selectedLanguage], tooltipQuestionChipsHeading2[selectedLanguage], tooltipQuestionChipsAudioContent[selectedLanguage], tooltipQuestionChipsContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "1.25rem",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
      placement: "top",
      target: lastQuestionChipsIdx !== undefined ? `#tour-question-chips-${lastQuestionChipsIdx}` : "#tour-question-chips-0",
      title: "",
      spotlightClicks: true,
      disableBeacon: true,
    },
    {
      content: tooltipContent(val, tooltipLoaderHeading1[selectedLanguage], tooltipLoaderHeading2[selectedLanguage], "", tooltipLoaderContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        footer: {
          display: "none",
        }
      },
      placement: "center",
      target: "body",
      hideFooter: true,
      hideNextButton: true,
    },
    {
      content: tooltipContent(val, tooltipStarHeading1[selectedLanguage], tooltipStarHeading2[selectedLanguage], tooltipStarAudioContent[selectedLanguage], tooltipStarContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "50%",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
      disableBeacon: true,
      spotlightClicks: true,
      placement: "auto",
      target: lastStarIdx !== undefined ? `#star-chat-block-${lastStarIdx}` : ".tour-speaker-chat-block:last-child",
      title: "",
    },
    {
      content: tooltipContent(val, tooltipSourceHeading1[selectedLanguage], tooltipSourceHeading2[selectedLanguage], tooltipSourceAudioContent[selectedLanguage], tooltipSourceContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "50%",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
      disableBeacon: true,
      spotlightClicks: false,
      placement: "bottom",
      target: lastSourceIdx !== undefined ? `#tour-source-block-${lastSourceIdx}` : ".tour-source-block:last-child",
      title: "",
    },
    {
      content: tooltipContent(val, tooltipEndHeading1[selectedLanguage], tooltipEndHeading2[selectedLanguage], tooltipEndAudioContent[selectedLanguage], tooltipEndContent[selectedLanguage]),
      styles: {
        options: {
          width: 380,
        },
        spotlight: {
          borderRadius: "50%",
          boxShadow: `
          0 0 0 20px rgba(255, 255, 255, 0.3),
          0 0 0 9999px rgba(0, 0, 0, 0.6)
          `,
        },
      },
      disableBeacon: true,
      spotlightClicks: false,
      placement: "bottom",
      target: "#tour-help-circle",
      title: "",
    },
  ];
  };
  useEffect(() => {
    setSteps(generateSteps(progress, lastQuestionChipsIdx, lastStarIdx));
  }, [progress, lastQuestionChipsIdx, lastStarIdx, isSpeakerOn, stepIndex]);

  useEffect(() => {
    if (start) {
      setRun(start);
      setStepIndex(0);
    }
  }, [start]);

  function handleStopAudio() {
    if (audioRef.current) {
      stopPlayingAudio(audioRef);
    }
  }

  const handleTooltipStepStatus = async (step, status) => {
    const res = await sendTooltipStepStatus(step, status);
    if (res?.status === 200) {
      updateTooltipFlag(step, status);
    }
    if (res?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
    if (res?.status === 500) {
      setToastErrorMessage(res?.data?.detail)
      setShowToastMessage(true);
    }
  };

  // --- Joyride callback: handle step transitions and user actions ---
  const handleJoyrideCallback = (data) => {
    // Destructure Joyride callback data
    const { status, type, index, action } = data;

    // Mark step as complete for analytics/tracking
    // (stepIndex is used to determine which step was just completed)
    switch (stepIndex) {
      case 3: handleTooltipStepStatus("speaker", true); break;
      case 5: handleTooltipStepStatus("typing", true); break;
      case 8: handleTooltipStepStatus("mic", true); break;
      case 13: handleTooltipStepStatus("chips", true); break;
      case 14: handleTooltipStepStatus("star", true); break;
      case 15: handleTooltipStepStatus("sources", true); break;
      default: break;
    }

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRun(false);
      setStepIndex(0);
      setStartTour(false);
      onTourEnd();
    }else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      const nextStepIndex = index + 1;

      if (speakerOpen && index === 1) {
        setTimeout(() => {
        setRun(true);
        setProgress(nextStepIndex + 1);
        }, 500);

      }else if(sendClicked && index === 4){
        setTimeout(() => {
          setRun(true);
          setProgress(nextStepIndex + 1);
        }, 500);
      }else if (optionClicked && index === 8){
        setTimeout(() => {
          setRun(true);
          setProgress(nextStepIndex + 1);
        }, 500);
      }else if (chipsClicked && index === 9){
        setTimeout(() => {
          setRun(true);
          setProgress(nextStepIndex + 1);
        }, 500);
      }else if (showQuestionChips && index === 10){
        setTimeout(() => {
          setRun(true);
          setProgress(nextStepIndex + 1);
        }, 500);
      }else if(questionChipsClicked && index === 11){
        setTimeout(() => {
          setRun(true);
          setProgress(nextStepIndex + 1);
        }, 1000);
      }else if (showTooltipStar && index === 12){
        setTimeout(() => {
          setRun(true);
          setProgress(nextStepIndex + 1);
        }, 1000);
      } else{
        if (type === EVENTS.STEP_AFTER && action === "next") {
          if (index === 2){
            setSpeakerEnabled(false);
            if(isSpeakerToggled){
              setIsSpeakerOn(true);
            }
          }else if (index === 3) {
            setIsSpeakerToggled(false);
            setInput(tooltipSendQuestion[selectedLanguage]);
          } else if (index === 4) {
            setInput("");
          }else if (index === 8){
            setOptionSelected(true);
            setOptionClicked(true);
          }else if (index ===9){
            setDefaultChipsClicked(true);
          }else if (index === 11){
            setDefaultQuestionChipsClicked(true);
          }
        }
        setStepIndex(nextStepIndex);
        setProgress(nextStepIndex + 1);
        handleStopAudio();
      }

    }
  };

  // --- Step progression logic: advance tour steps based on user actions ---
  useEffect(() => {
    if (speakerOpen && stepIndex === 1) {
      setRun(false);
      setStepIndex(2);
      if (isSpeakerOn){
        setIsSpeakerOn(false);
        setIsSpeakerToggled(true);
      }
    }else if (sendClicked && stepIndex === 4){
      setRun(false);
      setStepIndex(5);
    }else if (optionClicked && stepIndex === 8){
      setRun(false);
      setStepIndex(9);
    }else if (chipsClicked && stepIndex === 9){
      setRun(false);
      setStepIndex(10);
    }else if (showQuestionChips && stepIndex === 10){
      setRun(false);
      setStepIndex(11);
    }else if (questionChipsClicked && stepIndex === 11){
      setRun(false);
      setStepIndex(12);
    }else if (showTooltipStar && stepIndex === 12){
      setRun(false);
      setStepIndex(13);
    }
  }, [stepIndex, speakerOpen, optionClicked, chipsClicked, showQuestionChips, questionChipsClicked, showTooltipStar, sendClicked])
  
  return (
    <Joyride
      continuous
      callback={handleJoyrideCallback}
      run={run}
      steps={steps}
      stepIndex={stepIndex}
      disableOverlayClose
      hideCloseButton={true}
      spotlightPadding={5}
      showSkipButton={false}
      showBackButton={false}
      scrollTo={true}
      // debug
      scrollToFirstStep={true}
      styles={{
        arrow:{
          color: "white",
        },
        tooltipContainer: {
          height: "14.688rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          margin: 0,
          padding: 0,
        },
        tooltip: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "18.836rem",
            margin: "0",
            padding: "0",
            backgroundColor: "white",
            borderRadius: "1rem",
        },
        overlay: {
          opacity: 0.5,
        },
        buttonClose: {
          display: "none"
        },
        buttonBack: {
          display: "none"
        },
        buttonNext: steps[stepIndex]?.hideNextButton || !showNextButton ? { display: "none" } : {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.25rem",
          color: "var(--primary-dark)",
          fontWeight: 500,
          paddingLeft: "1rem",
          paddingRight: "1rem",
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem",
          borderRadius: "0.5rem",
          backgroundColor: "white",
          cursor: "pointer",
        },
        tooltipFooter: steps[stepIndex]?.hideFooter ? { display: "none" } : {
          height: "2.899rem",
          margin: "0px 16px 5px 10px",
          display: "flex",
          justifyContent: "center"
        },
        options: {
          zIndex: 100,
          arrowColor: "white",
          textColor: "var(--neutral-white)",
          margin: "0px",
          overlayColor: "rgba(0, 0, 0, 0.9)",
          primaryColor: "var(--primary-dark)",
          padding: 0,
        },
      }}
      locale={{
        next: steps[stepIndex]?.hideNextButton || !showNextButton ? "" : <strong className="flex items-center gap-2" aria-label="next">{tooltipButtons.next[selectedLanguage]} <span><img src="/Assets/Images/nextBlueIcon.svg" alt="Next" className="w-5 h-5" /></span></strong>,
        last: steps[stepIndex]?.hideNextButton || !showNextButton ? "" : <strong className="flex items-center gap-2" aria-label="last"><span><img src="/Assets/Images/checkBlue.svg" alt="Next" className="w-5 h-5" /></span> {tooltipButtons.finish[selectedLanguage]}</strong>,
      }}
    />
  );
};

export default Tooltip;
